import { MsalProvider } from '@azure/msal-react'
import i18n, { initializeI18N } from '@if/core/i18n'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import App from './containers/App/App'
import { store } from './data/store'
import { appActions } from './data/store/AppStore'
import './index.css'
import initializeAppInsights from './services/AppInsights'
import msalInstance, { initializeMsal } from './services/Authentification'
import { reportErrorToConsole, setupTracking } from './services/error-logger'

const ai = initializeAppInsights()
setupTracking(ai)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
const container = document.getElementById('root')
const root = createRoot(container!)
Promise.all([initializeMsal(), initializeI18N()])
  .then(() => {
    store.dispatch(appActions.setLanguage(i18n.language))
    root.render(
      <StrictMode>
        <Suspense fallback="loading">
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <Provider store={store}>
                <MsalProvider instance={msalInstance}>
                  <App />
                </MsalProvider>
              </Provider>
            </I18nextProvider>
          </QueryClientProvider>
        </Suspense>
      </StrictMode>,
    )
  })
  .catch(reportErrorToConsole)
